import theme from '@styles/theme';
export default {
  mainImageSkeleton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: theme.zIndex.documentHigh,
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    pointerEvents: 'none'
  },
  visualContainer: {
    position: 'relative'
  }
};